import { render, staticRenderFns } from "./Ranking-por-producto.vue?vue&type=template&id=7b704c84&scoped=true"
import script from "./Ranking-por-producto.vue?vue&type=script&lang=js"
export * from "./Ranking-por-producto.vue?vue&type=script&lang=js"
import style0 from "./Ranking-por-producto.vue?vue&type=style&index=0&id=7b704c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b704c84",
  null
  
)

export default component.exports